import { Alert, Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageContainer } from "../../components/primitives/layout/PageContainer";
import { LoadingTitle } from "../../components/primitives/data-display/LoadingTitle";
import { LoadingStage } from "../../components/domain/feedback/LoadingStage";
import { ErrorState } from "../../components/domain/feedback/ErrorState";
import { ClaimDisplay } from "../../components/domain/data-display/ClaimDisplay";
import { gaps } from "../../components/primitives/spacing";
import { useAnalysing } from "./useAnalysing";
import { ROUTES } from "../../route_paths";

/**
 * Fires the verification API call and shows a fun loading sequence.
 * Navigates to the result page once both the API and minimum step threshold are satisfied.
 */
export default function Analysing() {
  const { activeStepIndex, subMessage, steps, rateLimitError, apiError, claim } = useAnalysing();
  const { t } = useTranslation();

  const minutes = rateLimitError ? Math.max(1, Math.ceil(rateLimitError.retryAfter / 60)) : 0;

  return (
    <PageContainer center>
      {rateLimitError ? (
        <Stack gap={gaps.base} sx={{ width: "100%" }}>
          <Alert severity="info">{t("rateLimit.message", { count: minutes })}</Alert>
          <Button variant="outlined" component={Link} to={ROUTES.landing.path()}>
            {t("common.startOver")}
          </Button>
        </Stack>
      ) : apiError ? (
        <ErrorState
          code={apiError.code}
          action={
            <Button variant="outlined" component={Link} to={ROUTES.landing.path()}>
              {t("common.startOver")}
            </Button>
          }
        />
      ) : (
        <>
          <LoadingTitle>{t("analysing.title")}</LoadingTitle>
          {claim && <ClaimDisplay claim={claim.source_text} />}
          <LoadingStage steps={steps} activeStepIndex={activeStepIndex} subMessage={subMessage} />
        </>
      )}
    </PageContainer>
  );
}
